module.exports = __webpack_public_path__ + "static/img/icon-p1-6gs.efd0feda.png";